import { create } from "zustand";
import { createAppSlice } from "./createAppSlice";
import { createMenusSlice } from "./createMenusSlice ";
import { createCategoriesSlice } from "./createCategoriesSlice";
import { createItemsSlice } from "./createItemsSlice";
import { createPropertiesSlice } from "./createPropertiesSlice";
import { createBranchSlice } from "./createBranchSlice";
import { createSettingsSlice } from "./createSettingsSlice";
import { createOptionsSlice } from "./createOptionsSlice";
import { createUserSlice } from "./createUserSlice";
import { createStatisticsSlice } from "./createStatisticsSlice";
import { createCustomersSlice } from "./createCustomersSlice";
import { createLogsSlice } from "./createLogsSlice";
import { createNotificationsSlice } from "./createNotificationsSlice";
import { createOrdersSlice } from "./createOrdersSlice";
import { createCouponsSlice } from "./createCouponsSlice";

export const indexStore = create((...a) => ({
  ...createCustomersSlice(...a),
  ...createLogsSlice(...a),
  ...createAppSlice(...a),
  ...createMenusSlice(...a),
  ...createCategoriesSlice(...a),
  ...createItemsSlice(...a),
  ...createPropertiesSlice(...a),
  ...createBranchSlice(...a),
  ...createSettingsSlice(...a),
  ...createOptionsSlice(...a),
  ...createUserSlice(...a),
  ...createStatisticsSlice(...a),
  ...createNotificationsSlice(...a),
  ...createOrdersSlice(...a),
  ...createCouponsSlice(...a),
}));
